import React, { useEffect, useMemo, useState } from "react";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import {
  CLIENT_SATATUS_FILTER,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
} from "../../../../constant/constant";
import TableRowAction from "../../../../library/custom/gridTable/TableRowAction";
import { TableLoader } from "../../../../library/common/Loader";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import NORow from "../../../../library/custom/noRow/noRow";
import { useNavigate } from "react-router-dom";
import { ADMIN_ADD_PROJECT } from "../../../../constant/routeContant";
import DialogBox from "../../../../library/common/DialogBox";
import { Grid } from "@mui/material";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import FormControl from "@mui/material/FormControl";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import ServiceeFilterList from "../jha/serviceListFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { InactiveClient, sortAlphabetically } from "../../../../utils/helper";

const ProjectTable = ({
  projectsListData,
  getProjectListData,
  projectsListDatas,
  filterShow,
  deleteProject,
  isProjectsLoading,
  isProfile = false,
  divisionDropdown,
  isDivisionDropdown = true,
  checkbox,
  onRowClick,
  onSelectionModelChange,
  selectionModel,
  isShowDowdownloadButton = true,
  shouldRestoreState,
}) => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const openFilter = Boolean(anchorEl);
  const id = openFilter ? "simple-popover" : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const [filterFormValue, setFilterFormValue] = useState({
    // assetType: "",
    isActive: "",
  });

  const [isTableLoading, setisTableLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  const [openModal, setOpenModal] = useState(false);
  const [division, setDivision] = useState(
    divisionDropdown ? divisionDropdown[0]?.key : 0,
  );
  const [selectedRow, setSelectedRow] = useState("");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isProcoreClient = userInfo?.isProcoreConnected;
  const ProcoreClientId = localStorage.getItem("IsProcoreConnected");
  const isClientSwitch = parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID());

  let ShowField = false;

  if (isClientSwitch) {
    if (ProcoreClientId === "true") {
      ShowField = true;
    }
  } else {
    if (isProcoreClient) {
      ShowField = true;
    }
  }
  useEffect(() => {
    if (shouldRestoreState && projectsListDatas?.filterObj) {
      const f = projectsListDatas.filterObj;
      setSearch(f.search || "");
      setFilterFormValue({
        isActive: f.status === 0 ? 2 : f.status || "",
      });
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || PAGE_SIZE);
      setDivision(
        f.divisionId || (divisionDropdown ? divisionDropdown[0]?.key : 0),
      );
    }
  }, [shouldRestoreState]);
  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: division === "AllDivision" ? 0 : division,
      page: 1,
      pageSize: pageSize,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      search: searchText ? searchText : "",
      status: filterFormValue.isActive === 2 ? 0 : filterFormValue.isActive,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getProjectListData(data);
  };
  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: division === "AllDivision" ? 0 : division,
      pageSize: pageSize,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      search: search,
      page: newPage + 1,
      status: filterFormValue.isActive === 2 ? 0 : filterFormValue.isActive,
      isSendMail: false,
    };
    getProjectListData(data);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: division === "AllDivision" ? 0 : division,

      pageSize: newPazeSize,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      search: search,
      page: 1,
      status: filterFormValue.isActive === 2 ? 0 : filterFormValue.isActive,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getProjectListData(data);
  };
  const handleEditOnclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("projectListPreserveState", "true");
    navigate(ADMIN_ADD_PROJECT, {
      state: { id: rows.id, editMode: true },
    });
  };

  const onChangeDivision = (e) => {
    setDivision(e.target.value);
    setSearch("");
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: e.target.value === "AllDivision" ? 0 : e.target.value,
      page: 1,
      pageSize: pageSize,
      search: "",
      userId: isProfile ? parseInt(USER_ID()) : 0,
      status: filterFormValue.isActive === 2 ? 0 : filterFormValue.isActive,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getProjectListData(data);
    setPage(0);
  };

  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    deleteProject(selectedRow);
  };

  const deleteProjectHandle = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };
  const columns = [
    { field: "projectName", headerName: "Project Name", flex: 2.5 },
    { field: "id", headerName: "Project ID", flex: 1 },
    { field: "divisionName", headerName: "Division", flex: 1 },
    { field: "location", headerName: "Location", flex: 1 },
    { field: "startDate", headerName: "Start Date", flex: 1.5 },
    { field: "status", headerName: "Status", flex: 1 },

    ...(ShowField
      ? [
          {
            field: "procoreProjectId",
            headerName: "Procore Project",
            flex: 1.5,
            renderCell: (params) => {
              return params.row.procoreProjectId === null ? "No" : "Yes";
            },
          },
        ]
      : []),
    {
      field: "",
      width: 68,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return filterShow ? (
          <TableRowAction
            rows={rows}
            deleted={checkPrivileges([70, 12])}
            edit={checkPrivileges([70, 71, 12])}
            editOnClick={() => handleEditOnclick(rows)}
            deleteOnClick={() => deleteProjectHandle(rows.id)}
            deleteLabel="Delete Project"
            editLabel="Edit Project"
          />
        ) : (
          ""
        );
      },
    },
  ];
  function handleFilterClear(params) {
    setFilterFormValue({
      isActive: "",
    });
    setPage(0);
    setPageSize(PAGE_SIZE);
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: division === "AllDivision" ? 0 : division,
      page: 1,
      pageSize: PAGE_SIZE,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      search: "",
      status: "",
      isSendMail: false,
    };
    setSearch("");
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getProjectListData(data);
    setAnchorEl(null);
    window.close();
  }
  function handleFilterApply(params) {
    setPage(0);
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: division === "AllDivision" ? 0 : division,
      page: 1,
      pageSize: pageSize,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      search: search ? search : "",
      status: filterFormValue.isActive === 2 ? 0 : filterFormValue.isActive,
      isSendMail: false,
    };
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getProjectListData(data);
    setAnchorEl(null);
    window.close();
  }

  const sendEmail = () => {
    const data = {
      organisationId: isProfile ? LOGIN_ORG_ID() : ORG_ID(),
      divisionId: division === "AllDivision" ? 0 : division,
      page: page,
      pageSize: pageSize,
      userId: isProfile ? parseInt(USER_ID()) : 0,
      search: search ? search : "",
      status: filterFormValue.isActive === 2 ? 0 : filterFormValue.isActive,
      isSendMail: true,
    };
    getProjectListData(data);
  };

  const sortedDivisionDropdown = useMemo(() => {
    return sortAlphabetically(divisionDropdown);
  }, [divisionDropdown]);

  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          {openModal && (
            <DialogBox
              open={openModal}
              rows={[]}
              header={"Confirm Deletion"}
              deletehandle={deletehandle}
              handleCloseModal={() => setOpenModal(false)}
              content={"Are you sure you want to delete this Project?"}
              view
            />
          )}
        </div>
        <div className="grid_main_body divisionWithsearch">
          <div className="div-asset-filter-container">
            <div className="div-filter-left">
              <Grid container>
                <Grid item lg={4} xs={12} sm={6} md={4} mr={2} pt={3}>
                  <div className="filter_of_caselist">
                    <div className="searchcaseid">
                      <label htmlFor="search">
                        <span>
                          <SearchIcon />
                        </span>
                        <div>
                          <input
                            id="search"
                            placeholder="Search"
                            type="text"
                            value={search}
                            className=""
                            onChange={handleautoSearch}
                            autoComplete="off"
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                </Grid>

                <Grid item lg={3} xs={12} sm={6} md={3} mr={2} pt={3}>
                  <div className="filter_of_caselist">
                    <div className="filter_btn divisionWithFilter">
                      <button
                        aria-describedby={id}
                        variant="contained"
                        type="button"
                        name="btn"
                        onClick={(e) => handleClick(e)}
                      >
                        <FilterListIcon id="icn" /> Filters
                      </button>

                      <ServiceeFilterList
                        id={id}
                        open={openFilter}
                        anchorEl={anchorEl}
                        handleClose={() => {
                          setAnchorEl(null);
                          window.close();
                        }}
                        handleApply={() => handleFilterApply()}
                        secondLabel="Status"
                        secondLebelFilter={CLIENT_SATATUS_FILTER}
                        secondLebelValue={filterFormValue.isActive}
                        secondLebelOnChanges={(e) =>
                          setFilterFormValue({
                            ...filterFormValue,
                            isActive: e.target.value,
                          })
                        }
                        handleClear={() => handleFilterClear()}
                      />
                    </div>
                  </div>
                </Grid>
                {isDivisionDropdown && (
                  <Grid item lg={4} xs={12} sm={4} md={4}>
                    <FormControl fullWidth>
                      <FormLabels label="Select Division" isRequired={false} />
                      <SelectMenu
                        disabledDefault={true}
                        listData={sortedDivisionDropdown}
                        value={division === 0 ? "AllDivision" : division}
                        onchangehandler={(e) => onChangeDivision(e)}
                        isgroupplaceholder={true}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </div>
            {isShowDowdownloadButton && (
              <div className="div-filter-right-download" onClick={sendEmail}>
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>
            )}
          </div>
          {isTableLoading ? (
            ""
          ) : (
            <div className="desc_box row_uniq">
              <div className="table_style_ui">
                <GridTable
                  getRowId={(r) => r.id}
                  columns={columns}
                  rows={projectsListData?.projectData ?? []}
                  rowCount={projectsListData?.itemsCount ?? 0}
                  loading={isProjectsLoading}
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  onPageChange={handlePagignation}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  checkboxSelection={checkbox ? checkbox : false}
                  onRowClick={onRowClick ? onRowClick : false}
                  onSelectionModelChange={
                    onSelectionModelChange ? onSelectionModelChange : false
                  }
                  selectionModel={selectionModel ? selectionModel : false}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ProjectTable;
